
export default function Reviews() {
  const reviews = [
    {
      name: '高橋さん（32歳・会社員）',
      rating: 5,
      title: '本当に5分でカード番号が発行された！',
      comment: '急な出張でカードが必要になり、スピード発番で申し込みました。本当に5分程度でカード番号が発行されて、すぐにホテルの予約ができました。カード会社公式アプリも使いやすくて満足しています。',
      date: '2025年1月',
    },
    {
      name: '中村さん（26歳・フリーランス）',
      rating: 4,
      title: 'スマホ保険が意外と便利',
      comment: 'スマートフォン保険が付いているのが決め手でした。スマホの画面を割ってしまった時に保険が使えて助かりました。自己負担1万円はありますが、修理費用の足しになります。',
      date: '2024年12月',
    },
    {
      name: '山本さん（45歳・自営業）',
      rating: 5,
      title: '旅行保険が充実していて安心',
      comment: '国内・海外ともに旅行保険が最高3,000万円付いているのは一般カードとしては優秀。出張が多いので、この保険内容は非常にありがたいです。年会費も利用すれば無料になるので、コスパも良いと思います。',
      date: '2024年11月',
    },
    {
      name: '伊藤さん（29歳・会社員）',
      rating: 4,
      title: 'スタバでポイント20倍がお得',
      comment: 'スターバックスをよく利用するので、ポイント20倍は嬉しいです。通常還元率は低めですが、優待店を意識して使えばかなりポイントが貯まります。Apple Payにも対応しているので、スマホ決済派にもおすすめ。',
      date: '2024年10月',
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#F8F9FA] to-[#E8F5E9]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-3 text-center">
          利用者の口コミ・評判
        </h2>
        <p className="text-gray-600 text-center mb-12">実際に使っている人のリアルな声</p>

        <div className="grid md:grid-cols-2 gap-6">
          {reviews.map((review, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <p className="text-[#003366] font-bold text-sm">{review.name}</p>
                  <p className="text-gray-500 text-xs">{review.date}</p>
                </div>
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-${i < review.rating ? 'fill' : 'line'} text-[#FF9900] text-sm`}
                    ></i>
                  ))}
                </div>
              </div>
              <h4 className="text-[#003366] font-bold text-base mb-2">{review.title}</h4>
              <p className="text-gray-700 text-sm leading-relaxed">{review.comment}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <div className="inline-flex items-center gap-2 bg-white rounded-full px-6 py-3 shadow-md">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className={`ri-star-${i < 4 ? 'fill' : 'half-fill'} text-[#FF9900] text-lg`}></i>
              ))}
            </div>
            <span className="text-[#003366] font-bold text-lg">4.5</span>
            <span className="text-gray-600 text-sm">/ 5.0（856件のレビュー）</span>
          </div>
        </div>
      </div>
    </section>
  );
}
